module.exports = __webpack_public_path__ + "img/misja-105x63.7f926a0f.jpg";